// extracted by mini-css-extract-plugin
module.exports = {"pawLoader":"paw_pawLoader__fb0eO","paw":"paw_paw__S4r5I"};